import type { ChangeEvent } from 'react';

export function fieldChange<D, K extends keyof D>(
  data: D,
  onChange: (d: D) => void,
  key: K
): (e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void {
  return (e) => onChange({ ...data, [key]: e.target.value });
}
